<template>
  <div class="layout-wrapper layout-2">
    <div class="layout-inner">
      <app-layout-sidenav />

      <div class="layout-container">
        <app-layout-navbar />

        <div class="layout-content">
          <div class="edusystem-beta-banner">
            <div class="edusystem-beta-banner__content">
              <div class="edusystem-beta-banner__message">
                <span class="edusystem-beta-banner__badge">New beta</span>
                <strong>EduSystem is getting a major upgrade.</strong>
                Try the faster, cleaner new experience and help shape what comes next. If anything gets in your way, this version is still here for you.
              </div>
              <button type="button" class="btn btn-sm edusystem-beta-banner__button" @click="navigateToNewApp(getNewAppRoute())">
                Explore the new EduSystem
              </button>
            </div>
          </div>

          <div class="router-transitions container-fluid flex-grow-1 container-p-y">
            <router-view :key="$route.path" />
          </div>

          <app-layout-footer />
        </div>
      </div>
    </div>
    <div class="layout-overlay" @click="closeSidenav"></div>
  </div>
</template>

<script>
import LayoutNavbar from './LayoutNavbar'
import LayoutSidenav from './LayoutSidenav'
import LayoutFooter from './LayoutFooter'
import { navigateToNewAppMixin } from '@/mixins/NavigateToNewAppMixin'

export default {
  name: 'app-layout-2',
  mixins: [navigateToNewAppMixin],
  components: {
    'app-layout-navbar': LayoutNavbar,
    'app-layout-sidenav': LayoutSidenav,
    'app-layout-footer': LayoutFooter
  },

  mounted () {
    this.layoutHelpers.init()
    this.layoutHelpers.update()
    this.layoutHelpers.setAutoUpdate(true)
  },

  beforeDestroy () {
    this.layoutHelpers.destroy()
  },

  methods: {
    closeSidenav () {
      this.layoutHelpers.setCollapsed(true)
    },
    getNewAppRoute () {
      const path = this.$route.path
      const mappings = [
        { old: /^\/$/, next: '' },
        { old: /^\/accounts/, next: 'accounts' },
        { old: /^\/sections/, next: 'curriculum' },
        { old: /^\/courses/, next: 'curriculum/courses' },
        { old: /^\/classes/, next: 'curriculum/educator-classes' },
        { old: /^\/learners/, next: 'learners' },
        { old: /^\/guardians/, next: 'learners/guardians' },
        { old: /^\/subjects|^\/assessments|^\/marks/, next: 'assessments' },
        { old: /^\/markbook/, next: 'markbook' },
        { old: /^\/attendance/, next: 'attendance' },
        { old: /^\/subjectcomments|^\/classcomments|^\/nonacademiccomments|^\/templatecomments/, next: 'comments' },
        { old: /^\/reports|^\/transcripts|^\/emailreports/, next: 'reports' },
        { old: /^\/analysis|^\/graderanking|^\/classranking|^\/pass-overview|^\/finalschedule/, next: 'analysis' },
        { old: /^\/finance|^\/statement|^\/emailstatement/, next: 'finance' },
        { old: /^\/incident/, next: 'incidents' },
        { old: /^\/meeting/, next: 'meetings' },
        { old: /^\/educators/, next: 'school-admin/educators' }
      ]
      const match = mappings.find((item) => item.old.test(path))

      return match ? match.next : ''
    }
  }
}
</script>

<style scoped>
.edusystem-beta-banner {
  background: linear-gradient(90deg, #e7f7ff 0%, #f2fbff 55%, #ffffff 100%);
  border-bottom: 1px solid #a7dcf5;
  box-shadow: 0 2px 10px rgba(37, 169, 225, .08);
  color: #16435c;
  padding: .85rem 1.5rem;
}

.edusystem-beta-banner__content {
  align-items: center;
  display: flex;
  gap: 1rem;
  justify-content: space-between;
}

.edusystem-beta-banner__message {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: .45rem;
}

.edusystem-beta-banner__badge {
  background: #25a9e1;
  border-radius: 999px;
  color: #fff;
  display: inline-flex;
  font-size: .72rem;
  font-weight: 700;
  letter-spacing: .02em;
  line-height: 1;
  padding: .35rem .6rem;
  text-transform: uppercase;
}

.edusystem-beta-banner__button {
  background: #0b86bd;
  border-color: #0b86bd;
  color: #fff;
  font-weight: 600;
  white-space: nowrap;
}

.edusystem-beta-banner__button:hover,
.edusystem-beta-banner__button:focus {
  background: #076f9e;
  border-color: #076f9e;
  color: #fff;
}

@media (max-width: 767.98px) {
  .edusystem-beta-banner__content {
    align-items: flex-start;
    flex-direction: column;
  }
}
</style>
